import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import { ability, abilityPlugin } from './ability'; // Updated import statement

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [abilityPlugin],
  modules,
  state: {
    rules: []
  },
  getters: {
    ability() {
      return ability; // Use the ability instance directly
    }
  },
  mutations: {
    setRules(state, rules) {
      state.rules = rules;
      ability.update(rules); // Ensure ability is updated here as well
    }
  },
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
